import {Button, Menu, MenuHandler, MenuItem, MenuList, Typography,} from "@material-tailwind/react";
import {BsPerson, BsPersonBadge, BsPersonCheck} from "react-icons/bs";
import {useEffect, useState} from "react";
import {getPersonRole, roleSwitch} from "../../services/user/login";
import Dict from "../../helper/dict";
import authManager from "../../helper/AuthHelper";

export function RolesMenu({onClick}) {

  const [roles, setRoles] = useState([]);

  const [selectedRole, setSelectedRole] = useState(false);

  useEffect(() => {
    async function getData() {
      const result = await getPersonRole();
      if (result.status === 200) {
        const {roleList, role_id} = result.data;
        setRoles(roleList || []);
        setSelectedRole(role_id === 2 ? "agent" : role_id === 3 ? "user" : role_id === 1 ? "admin" : role_id === 5 ? "support" : "back_office")
      }
    }

    getData()
  }, []);


  async function changeRole(id) {
    const data = {
      role_id: id,
    };
    let result;

    result = await roleSwitch(data);

    if (result.status === 200) {
      // const {token, userInfo, expiration} = loginData;
      authManager.loginHandler(result.data)
      localStorage.removeItem("lastClicked")
      window.location.href = '/';
    }
  }

  return (
    roles.length > 1 && selectedRole &&
    <Menu>
      <MenuHandler>
        <Button variant="outlined" size="sm md:lg" className="flex flex-row px-1 md:gap-x-2 px-2">
          <BsPersonBadge size="2em" className="flex flex-col hidden md:block"/>
          <Typography className="flex flex-col">
            تغییر نقش
          </Typography>
        </Button>
      </MenuHandler>
      <MenuList className="flex flex-col gap-2 px-4 mx-4 py-8">
        {
          roles.map(({title, id}) => (
              <MenuItem key={id}
                        className={"flex items-center gap-4 py-2 pl-2 pr-4 border-b " + (title === selectedRole ? "bg-green-500 text-white" : "")}
                        onClick={() => changeRole(id)}>
                {title === selectedRole &&
                  <BsPersonCheck size={25}/>
                }
                {title !== selectedRole &&
                  <BsPerson size={25}/>
                }
                <div className="flex flex-col gap-1">
                  <Typography variant="small" color={(title === selectedRole ? "white" : "gray")}
                              className={"font-semibold"}>
                    {Dict(title)}
                  </Typography>
                </div>
              </MenuItem>
            )
          )

        }

      </MenuList>
    </Menu>
  );
}